module.exports = __webpack_public_path__ + "media/public/img/market_pulse/market_pulse-1-0a5220b3d29e4a0de46fb7534bebe030.svg";